type LocaleChangeMessage = { type: 'locale_change'; localeCode: string };
type DeviceSelectedMessage = { type: 'device_selected'; device: string };
type DevicePickerClosedMessage = { type: 'device_picker_closed' };
type CartUpdatedMessage = { type: 'cart_updated'; total: number };
type ReviewPromptMessage = { type: 'review_prompt_requested'; trigger: string; idleMS?: number };
type WorkbenchUpdatedMessage = { type: 'workbench_updated' };

declare global {
   interface Window {
      ReactNativeWebView?: {
         postMessage: (message: string) => void;
      };
   }
}

type ReactNativeMessage =
   | LocaleChangeMessage
   | DeviceSelectedMessage
   | DevicePickerClosedMessage
   | CartUpdatedMessage
   | ReviewPromptMessage
   | WorkbenchUpdatedMessage;
export function sendReactNativeMessage(message: ReactNativeMessage) {
   if (typeof window === 'undefined') {
      return;
   }
   window.ReactNativeWebView?.postMessage(JSON.stringify(message));
}
